import { SimSearch } from '@/features/dashboard/sim-search/SimSearch'
import { SimSearchSchema } from '@/features/dashboard/sim-search/simSearchSchema'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/search/')({
  component: RouteComponent,
  validateSearch: SimSearchSchema
})

function RouteComponent() {
  return <SimSearch />
}
